export default "__VITE_ASSET__244f2fd2__"